<mat-card class="results-by-store">
    <div class="section-title">RESULTS BY STORE</div>
    <div class="results-by-store-wrapper">
        <table class="results-by-store-table">
            <colgroup>
                <col class="col-store">
                <col class="col-today-sales">
                <col class="col-today-labour">
                <col class="col-week-sales">
                <col class="col-week-labour">
            </colgroup>
            <thead>
                <tr>
                    <th (click)="sortBy('name')">
                        <div class="th-content">
                            <span>STORE</span>
                            <span class="sort-icon">
                                <span class="up">&#9650;</span>
                            </span>
                        </div>
                    </th>
                    <th colspan="2">TODAY</th>
                    <th colspan="2">THIS WEEK</th>
                </tr>
                <tr>
                    <th></th>
                    <th (click)="sortBy('todaySales')">
                        <div class="th-content">
                            <span>SALES</span>
                            <span class="sort-icon">
                                <span class="up">&#9650;</span>
                                <span class="down">&#9660;</span>
                            </span>
                        </div>
                    </th>

                    <th (click)="sortBy('todayLabour')">
                        <div class="th-content">
                            <span>LABOUR%</span>
                            <span class="sort-icon">
                                <span class="up">&#9650;</span>
                                <span class="down">&#9660;</span>
                            </span>
                        </div>
                    </th>

                    <th (click)="sortBy('weekSales')">
                        <div class="th-content">
                            <span>SALES</span>
                            <span class="sort-icon">
                                <span class="up">&#9650;</span>
                                <span class="down">&#9660;</span>
                            </span>
                        </div>
                    </th>

                    <th (click)="sortBy('weekLabour')">
                        <div class="th-content">
                            <span>LABOUR%</span>
                            <span class="sort-icon">
                                <span class="up">&#9650;</span>
                                <span class="down">&#9660;</span>
                            </span>
                        </div>
                    </th>
                </tr>

            </thead>
            <tbody>
                <tr *ngFor="let store of stores">
                    <td class="store-name">
                        <ng-container *ngIf="store.shopType === 'DT'">
                            <span class="dt-star">&#9733;</span>
                        </ng-container>
                        <a href="#" class="shop-link" (click)="onShopClick(store); $event.preventDefault()">{{
                            store.name }}</a>
                    </td>
                    <td class="text-right store_data"
                        [ngStyle]="store.todaySalesChange >= 0 ? {'color':'green'} : {'color':'red'}">
                        {{ store.todaySales | currency:'USD':'symbol':'0.0-0' }}
                        <img style="width:12px;vertical-align:middle;"
                            [src]="store.todaySalesChange >= 0 ? 'assets/images/arrows/up.png' : 'assets/images/arrows/down.png' "
                            alt="arrow" />
                        {{ (store.todaySalesChange !== null ? (store.todaySalesChange < 0 ? -store.todaySalesChange :
                            store.todaySalesChange) : 0) | number:'1.1-1' }}% LY </td>
                    <td class="text-right store_data" *ngIf="store.todayLabourChange !== null"
                        [ngStyle]="store.todayLabourChange >= 0 ? {'color':'red'} : {'color':'green'}">
                        {{ store.todayLabour | number:'1.1-1' }}%
                        <img style="width:12px;vertical-align:middle;"
                            [src]="store.todayLabourChange >= 0 ? 'assets/images/arrows/up_red.png' : 'assets/images/arrows/down_green.png' "
                            alt="arrow" />
                        {{ (store.todayLabourChange !== null ? (store.todayLabourChange < 0 ? -store.todayLabourChange :
                            store.todayLabourChange) : 0) | number:'1.2-2' }}% LY </td>
                    <td class="text-right store_data" *ngIf="store.todayLabourChange === null"
                        [ngStyle]="{'color':'green'}">
                        {{ (store.todayLabour + 0) | number:'1.1-1' }}%
                        <img style="width:12px;vertical-align:middle;" src="assets/images/arrows/up.png" alt="up" />
                        0.00% LY
                    </td>
                    <td>
                        <span [ngStyle]="{ color: store.weekSalesChange >= 0 ? 'green' : 'red' }">
                            {{ store.weekSales | currency:'USD':'symbol':'0.0-0' }}
                        </span>
                        <span>
                            <img *ngIf="store.weekSalesChange >= 0" src="assets/images/arrows/up.png" alt="up"
                                style="width:12px;vertical-align:middle;" />
                            <img *ngIf="store.weekSalesChange < 0" src="assets/images/arrows/down.png" alt="down"
                                style="width:12px;vertical-align:middle;" />
                        </span>
                        <span [ngStyle]="{ color: store.weekSalesChange >= 0 ? 'green' : 'red' }">
                            {{ (store.weekSalesChange !== null ? (store.weekSalesChange < 0 ? -store.weekSalesChange :
                                store.weekSalesChange) : 0) | number:'1.1-1' }}% LY </span>
                    </td>
                    <td class="text-right store_data" *ngIf="store.weekLabourChange !== null"
                        [ngStyle]="store.weekLabourChange >= 0 ? {'color':'red'} : {'color':'green'}">
                        {{ store.weekLabour | number:'1.1-1' }}%
                        <img style="width:12px;vertical-align:middle;"
                            [src]="store.weekLabourChange >= 0 ? 'assets/images/arrows/up_red.png' : 'assets/images/arrows/down_green.png' "
                            alt="arrow" />
                        {{ store.weekLabourChange < 0 ? -store.weekLabourChange : store.weekLabourChange |
                            number:'1.1-1' }}% LY </td>
                    <td class="text-right store_data" *ngIf="store.weekLabourChange === null"
                        [ngStyle]="{'color':'green'}">
                        {{ (store.weekLabour + 0) | number:'1.1-1' }}%
                        <img style="width:12px;vertical-align:middle;" src="assets/images/arrows/up.png" alt="up" />
                        0.00% LY
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr class="total-row">
                    <td class="text-left container_fixed"><b>TOTAL(Exclude DT)</b></td>
                    <td class="text-right store_data"
                        [ngStyle]="totalRow.todaySalesChange >= 0 ? {'color':'green'} : {'color':'red'}">
                        {{ totalRow.todaySales | currency:'USD':'symbol':'0.0-0' }}
                        <img style="width:12px;vertical-align:middle;"
                            [src]="totalRow.todaySalesChange >= 0 ? 'assets/images/arrows/up.png' : 'assets/images/arrows/down.png' "
                            alt="arrow" />
                        {{ (totalRow.todaySalesChange !== null ? (totalRow.todaySalesChange < 0 ?
                            -totalRow.todaySalesChange : totalRow.todaySalesChange) : 0) | number:'1.1-1' }}% LY </td>
                    <td class="text-right store_data"
                        [ngStyle]="totalRow.todayLabourChange >= 0 ? {'color':'red'} : {'color':'green'}">
                        {{ totalRow.todayLabour | number:'1.1-1' }}%
                        <img style="width:12px;vertical-align:middle;"
                            [src]="totalRow.todayLabourChange >= 0 ? 'assets/images/arrows/up_red.png' : 'assets/images/arrows/down_green.png' "
                            alt="arrow" />
                        {{ (totalRow.todayLabourChange !== null ? (totalRow.todayLabourChange < 0 ?
                            -totalRow.todayLabourChange : totalRow.todayLabourChange) : 0) | number:'1.1-1' }}% LY </td>
                    <td class="text-right store_data"
                        [ngStyle]="totalRow.weekSalesChange >= 0 ? {'color':'green'} : {'color':'red'}">
                        {{ totalRow.weekSales | currency:'USD':'symbol':'0.0-0' }}
                        <img style="width:12px;vertical-align:middle;"
                            [src]="totalRow.weekSalesChange >= 0 ? 'assets/images/arrows/up.png' : 'assets/images/arrows/down.png' "
                            alt="arrow" />
                        {{ (totalRow.weekSalesChange !== null ? (totalRow.weekSalesChange < 0 ?
                            -totalRow.weekSalesChange : totalRow.weekSalesChange) : 0) | number:'1.1-1' }}% LY </td>
                    <td class="text-right store_data"
                        [ngStyle]="totalRow.weekLabourChange >= 0 ? {'color':'red'} : {'color':'green'}">
                        {{ totalRow.weekLabour | number:'1.1-1' }}%
                        <img style="width:12px;vertical-align:middle;"
                            [src]="totalRow.weekLabourChange >= 0 ? 'assets/images/arrows/up_red.png' : 'assets/images/arrows/down_green.png' "
                            alt="arrow" />
                        {{ (totalRow.weekLabourChange !== null ? (totalRow.weekLabourChange < 0 ?
                            -totalRow.weekLabourChange : totalRow.weekLabourChange) : 0) | number:'1.1-1' }}% LY </td>
                </tr>
            </tfoot>
        </table>
    </div>

</mat-card>